import {Component, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, inject, DestroyRef, afterNextRender, PLATFORM_ID} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {DecimalPipe, UpperCasePipe, isPlatformBrowser} from '@angular/common';
import {RouterLink} from '@angular/router';
import {Subscription, tap} from 'rxjs';
import {CryptoCoin, CryptoService} from '../../services/crypto.service';
import {rNames} from '../../../app/r.names';

/** Бегущая лента топ-монет в шапке: цена ₽ + изменение за 24ч. */
@Component({
    selector: 'app-crypto-ticker',
    templateUrl: './crypto-ticker.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, DecimalPipe, UpperCasePipe]
})
export class CryptoTickerComponent implements OnDestroy {
  private crypto = inject(CryptoService);

  private readonly cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);


  protected readonly r = rNames;

  coins: CryptoCoin[] = [];
  /** API упал/лимит — ленту прячем, сайт не ломается */
  failed = false;

  private sub?: Subscription;

  constructor() {
    // Browser only (#1175): prices in the header carry no SEO value, and in SSR this request made
    // every page wait for CoinGecko (up to the upstream timeout when it hangs). The server renders
    // an empty ticker; the browser fills it in. getTop() shares the request and refreshes every 2 min.
    if (isPlatformBrowser(inject(PLATFORM_ID))) {
      afterNextRender(() => this.load());
    }
  }

  private load(): void {
    this.sub = this.crypto.getTop(6).pipe(takeUntilDestroyed(this.destroyRef), tap({next: () => this.cdr.markForCheck(), error: () => this.cdr.markForCheck(), complete: () => this.cdr.markForCheck()})).subscribe({
      next: coins => {
        this.coins = coins;
        this.failed = false;
      },
      error: () => this.failed = true
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
